export interface FilterOption {
  value: string;
  label: string;
}

interface FilterGroupProps {
  label: string;
  options: FilterOption[];
  value: string;
  onSelect: (value: string) => void;
  full?: boolean;
}

export default function FilterGroup({ label, options, value, onSelect, full }: FilterGroupProps) {
  return (
    <div className={`flex flex-col sm:flex-row gap-2 sm:gap-4 py-3 ${full ? "" : ""}`}>
      <span className="shrink-0 w-16 pt-1 text-sm text-foreground-500 font-label">{label}</span>
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const active = option.value === value;
          return (
            <button
              key={option.value}
              type="button"
              onClick={() => onSelect(option.value)}
              className={`px-3 py-1.5 rounded-md text-sm font-label transition-colors whitespace-nowrap cursor-pointer ${
                active
                  ? "bg-primary-600 text-white"
                  : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </div>
  );
}